import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { CardSkeleton } from './CardSkeleton';

const CardSkeletonsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${spacing.plusHalf};
  padding-top: ${spacing.plusHalf};
`;

export const OverviewLoadingSkeleton = ({ numOfCards = 6 }: { numOfCards: number }) => {
  const CardSkeletons = [...Array(numOfCards).keys()].map((idx) => (
    <CardSkeleton key={`skeleton-card-${idx}`} />
  ));

  return (
    <div>
      <CardSkeletonsWrapper>{CardSkeletons}</CardSkeletonsWrapper>
    </div>
  );
};
